import { useFeatureFlagEnabled } from "posthog-js/react";
import { NavLink } from "react-router";
import { NavigationMenuLink } from "~/atoms/navigation-menu";
import { featureFlags } from "~/config/featureFlags";
import { useText } from "./text";

// For the Workflows dropdown: the page has no other way in, so the flag shows it there
export const AnnualWheelPrototypeNavItem = () => {
  const isEnabled = useFeatureFlagEnabled(featureFlags.annualWheelPrototype);
  const text = useText();

  if (!isEnabled) return null;

  return (
    <li>
      <NavigationMenuLink asChild>
        <NavLink to="/dev/annual-wheel">{text.menuLabel}</NavLink>
      </NavigationMenuLink>
    </li>
  );
};
